import { InitAdapter, SubmitAdapter } from '../../types';
import { isPcpDirty } from '../../utils/form';

export const initAdapter: InitAdapter = ({ pcp }) => {
  const attachments = (pcp?.assets || []).map(asset => ({
    name: asset.filename,
    size: asset.filesize,
    type: asset.type,
    deviationId: asset.isOriginal ? 0 : asset.deviationId,
    fileId: asset.fileId,
  }));

  return attachments;
};

export function useSubmitAdapter(
  /**
   * Will bypass the {@link isPcpDirty} check we make before adding attachment relevant data to the submit request.
   */
  allowCleanFieldSubmit?: boolean
): SubmitAdapter {
  return ({ originalAttached, showAttachments }, formState) => {
    if (!isPcpDirty(formState) && !allowCleanFieldSubmit) {
      return {};
    }

    return showAttachments === false
      ? { pcp_price_points: 0 }
      : { pcp_include_original: originalAttached };
  };
}

export const originalAttachedInitAdapter: InitAdapter = ({ pcp }) =>
  pcp?.includesOriginal ?? true;
